export enum CurrentCheckInStatus {
  VERIFYING_IDENTITY = 'Verifying Identity',
  SUBMITTING_ADDITIONAL_DETAILS = 'Submitting Additional Details',
}
